import React from 'react';

interface ContentElementContainerProps {
    readonly children: React.ReactNode;
}

export const ContentElementContainer: React.FC<ContentElementContainerProps> = ({ children }) => (
    <div className="bg-white p-2 sm:p-4 rounded-sm shadow-sm text-grey min-h-0">{children}</div>
);
